import { Component, inject, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { Organisation } from '../_shared/models/csTypes/organisation';
import { toSignal } from '@angular/core/rxjs-interop';
import { AdminService } from '../admin/admin.service';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { AuthService } from '../auth/auth.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-select-organisation',
  templateUrl: './select-organisation.component.html',
  styleUrls: ['./select-organisation.component.scss'],
  standalone: true,
  imports: [
    CommonModule, 
    FormsModule, 
    ReactiveFormsModule,
    IonicModule,
    TranslateModule
]
})
export class SelectOrganisationComponent  implements OnInit {
     authService = inject(AuthService);
    private fb = inject(FormBuilder)
    private adminService = inject(AdminService);
    @Input() organisationId: any | null = null;
    @Input() policyId: any | null = null;
    @Output() organisationChange = new EventEmitter<string>();
    @Output() policyChange = new EventEmitter<string>();
    @Input() isEdit = false;
    organisations$: Observable<Organisation[]> =  this.adminService.getOrganisations();
    organisations = toSignal(this.organisations$);
    organisationPolicy: any;
    form: FormGroup;

  constructor() { }

  ngOnInit() {
    this.buildForm();
  }

  buildForm(){
    this.form = this.fb.group({
        policy: [this.policyId?._id], // this.tournament?.policy?._id
        organisation: [this.organisationId?._id], // this.tournament?.organisation?._id
    })

     if (this.isEdit) {
        this.organisationPolicy = this.organisationId?.policies;
      }
  }

  onOrganisationSelected(event: any) {
        const selectedOrganisationId = event.detail.value; // Get the selected value
        this.organisationChange.emit(selectedOrganisationId);
        const selectedOrganisation = this.organisations()?.find(
            (o) => o._id === selectedOrganisationId
          );
          this.organisationPolicy = selectedOrganisation?.policies;
          if(!this.organisationPolicy.length){
            this.form.patchValue({ policy: null});
          }
      }
    onPolicySelected(event: any) {
        const selectedPolicyId = event.detail.value;
        this.policyChange.emit(selectedPolicyId);
    }
}
